export const keyfectorsData = [
  "Writing an essay is easy when you hire our scholars to help with topic selection, outlines, and research.",
  "Our assignment help service is trusted nationwide for supporting students with all kinds of homework by hiring top scholars from every academic field.",
  "Our dissertation service solves all writing issues with proposals, literature reviews, data collection, and expert guidance.",
  "For coursework help, rely on our custom experts to assist with various topics, editing, and proofreading to boost your grades.",
];
